/**
 * Group Table Component
 * 
 * Displays a data table with group information using TanStack Table
 * - Generic DataTable component wrapper
 * - Pre-configured group columns
 * - Sorting and custom cell renderers
 * - Action buttons (edit, view)
 * 
 * @component
 * @example
 * <GroupTable
 *   groups={groups}
 *   loading={false}
 *   onEdit={(group) => console.log('Edit', group)}
 *   onView={(group) => console.log('View', group)}
 * />
 */

import { FC, useMemo } from 'react';
import DataTable from '@/components/DataTable/DataTable';
import { createGroupColumns } from '@/components/DataTable/groupColumns';
import type { GroupTableProps } from './GroupTable.types';

const GroupTable: FC<GroupTableProps> = ({
  groups,
  loading = false,
  onEdit,
  onView,
  onManage,
}) => {
  // Create columns with actions memoized
  const columns = useMemo(
    () =>
      createGroupColumns({
        onEdit,
        onView,
        onManage,
      }),
    [onEdit, onView, onManage]
  );

  return (
    <DataTable
      data={groups}
      columns={columns}
      isLoading={loading}
      enableSorting={true}
      enablePagination={false}
      emptyMessage="Nenhum grupo encontrado"
      showSkeleton={true}
    />
  );
};

export default GroupTable;
